export default __webpack_public_path__ + "static/media/arrow-collapse.b53d677f.svg";